module.exports = __webpack_public_path__ + "public/Icons/notVerified.svg?6a06956b";